import { number, object, string } from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import StarRating from './StarRating';
import Avatar from 'react-avatar';
import { FaQuoteLeft } from 'react-icons/fa';

export default function SiteReview({ reviewData, width, symbol }) {
    return (<div
        className={'site-review'}
        style={{
            width: `${width}${symbol}`,
        }}>
        <div
            className={'site-review--message'}>
            <FaQuoteLeft
                className={'site-review--message-icon'}
                color={'var(--action-color)'}
                size={'25px'} />
            {reviewData.message ?? 'No feedback given.'}
        </div>
        <div
            className={'site-review--author-panel'}>
            <Row
                className={'site-review--data-row'}>
                <Col
                    className={'site-review--left-col'}>
                    <a
                        className={'site-review--author-link'}
                        href={reviewData.url}>{reviewData.name}</a>
                    <span
                        style={{
                            whiteSpace: 'nowrap',
                        }}>
                        <StarRating
                            rating={reviewData.stars} />
                    </span>
                </Col>
                <Avatar
                    name={reviewData.name}
                    color={'#ccc'}
                    size={'50px'}
                    round={'2.5px'} />
            </Row>
        </div>
    </div>);
}

SiteReview.propTypes = {
    reviewData: object,
    width: number,
    symbol: string,
};